import {  Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSelector } from 'src/reducers';
import { useEffect, useState } from 'react';
import {  DashboardInvoiceDataRequest } from 'src/actions/dashboardActions';
import RenderGraph from './RenderGraph';

export default function DashboardProjectInvoiceSection() {

  const [ filter, setFilter] = useState<any>({type:1});
  const dispatch = useDispatch();
  const dashboardData = useSelector(state => state.dashboard);
  const { dashboardProjectInvoiceSectionData } = dashboardData;

  var dates: any = [];
  var total: any = [];
  var count: any = [];

  dashboardProjectInvoiceSectionData.map((revenue: any) =>
    dates.push(revenue.date) && total.push(revenue.total) && count.push(revenue.count) 
  );

  useEffect(() => {
    dispatch(DashboardInvoiceDataRequest(filter))
  }, [filter])

  const CHART_DATA = [
    {
      name: 'Amount',
      data: total
    },
    {
      name: 'Count',
      data: count
    },
  ];


  var options: any = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: dates
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val: number) {
          return val
        }
      }
    }
  };

  return (
    <Grid item xs={12} md={6} lg={6}>
      <RenderGraph filterType={['client']} filter={filter} setFilter={setFilter} title="Project Invoice" subheader="This Year" chartdata={CHART_DATA} options={options} type="bar" />
    </Grid>
  );
}
